module.exports = fox._r("images/ff.png", __webpack_public_path__ + "_/_/_/common/frame/images/ff.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/ff.png
// module id = 159
// module chunks = 2